module.exports = __webpack_public_path__ + "static/media/district_icon.0e0da20a.svg";